import { IAttribute } from 'app/model/base/annotation';
import { IExpressionResolution } from 'app/model/expressions/expression-resolution';
import { Owned } from 'app/model/base/named';
import type { AzLgcExpDocument } from 'monaco-azure-logic-app-lang';
import { ExpressionCategory } from 'shell-models-lib';

export interface IResolutionObj {
    resolve: (expression: string) => IExpressionResolution;
    getExpressionCategory: (expression: string) => ExpressionCategory;
    getExpressionShorthand: (expression: string) => string;
}

/**
 * Resolves expression syntax into expression objects. Validates type matching and expression correctness.
 * Gradually we gonna rename this into AzureLogicAppExpressionLanguageService
 * @deprecated
 */
export abstract class ExpressionResolverService {

    public abstract buildParserV2FromOwnedAndAttribute(owned: Owned, _field: IAttribute): {
        parse: (text: string) => AzLgcExpDocument;
    };

    /**
     * We gonna gradually deprecate this method and migrate to the next gen builder: buildParserV2FromOwnedAndAttribute
     * @deprecated
     * @param entity
     * @param field
     */
    public abstract given(entity: Owned, field: IAttribute): IResolutionObj;
}
